import sendBasketReq from './helpers/basketFetch';
import { storageGet } from '../libs/localStorage';

const updateBasketElements = async (formData) => {
  if (formData) {
    const response = await sendBasketReq(formData);
    if (response) {
      const html = document.createElement('div');
      html.innerHTML = response;
      const basketContainer = document.querySelector('#basket-container');
      if (basketContainer) {
        basketContainer.innerHTML = html.querySelector('#basket-container').innerHTML;
        window.cartInit();
      }
    }
  }
};

const changeInputHandler = async (input) => {
  const id = input.dataset.itemId;
  const quantityKey = `basket[QUANTITY_${id}]`;
  const deleteKey = `basket[DELETE_${id}]`;
  const value = parseInt(input.value, 10);
  const mode = input.dataset.mode;
  const data = {
    basketAction: 'refreshAjax',
  };

  // Если кол-во равно нулю и товар находится в блоке "Готово к отгрузке", то удаляем позицию
  // Если кол-во равно нулю и товар находится только в блоке "На складе производителя", то удаляем позицию
  if (value === 0) {
    if (mode === 'in-stock' || (mode === 'on-order' && parseInt(input.dataset.inStock, 10) === 0)) {
      data[deleteKey] = 'Y';
    } else {
      data[quantityKey] = parseInt(input.value, 10) + parseInt(input.dataset.inStock, 10);
    }
  } else if (mode === 'on-order') {
    data[quantityKey] = parseInt(input.value, 10) + parseInt(input.dataset.inStock, 10);
  } else {
    data[quantityKey] = parseInt(input.value, 10) + parseInt(input.dataset.onOrder, 10);
  }

  const scoreInput = document.querySelector('[data-input-type="jsPointsInput"]');
  if (scoreInput) {
    data.partnerScore = scoreInput.value;
    data.fullRecalculation = 'Y';
  }

  const formData = new FormData();
  const dataKeys = Object.keys(data);

  for (let i = 0; i < dataKeys.length; i++) {
    formData.append(dataKeys[i], data[dataKeys[i]]);
  }
  await updateBasketElements(formData);
};

const initQuantityBlock = () => {
  const quantityBlocks = document.querySelectorAll('[data-entity="basket-item-quantity-block"]');
  let timeOut = 0;
  quantityBlocks.forEach((el) => {
    const inputField = el.querySelector('[data-entity="basket-item-quantity-field"]');
    const measureRatio = parseInt(inputField.dataset.measureRatio, 10);
    el.querySelector('[data-entity="basket-item-quantity-minus"]').addEventListener('click', () => {
      const value = parseInt(inputField.value, 10);
      if (value > 0) {
        inputField.value = value - measureRatio;
        clearTimeout(timeOut);
        timeOut = setTimeout(() => {
          changeInputHandler(inputField);
        }, 500);
      }
    });
    el.querySelector('[data-entity="basket-item-quantity-plus"]').addEventListener('click', () => {
      const value = parseInt(inputField.value, 10);
      inputField.value = value + measureRatio;
      clearTimeout(timeOut);
      timeOut = setTimeout(() => {
        changeInputHandler(inputField);
      }, 500);
    });
  });
};

const initQuantityInputs = () => {
  const quantityInputs = document.querySelectorAll('[data-entity="basket-item-quantity-field"]');
  quantityInputs.forEach((el) => {
    el.addEventListener('change', (event) => {
      changeInputHandler(event.target);
    });
  });
};

const initDeleteButtons = () => {
  const items = document.querySelectorAll('[data-entity="basket-item"]');
  items.forEach((el) => {
    const deleteButton = el.querySelector('[data-entity="basket-item-delete"]');
    deleteButton.addEventListener('click', () => {
      const input = el.querySelector('[data-entity="basket-item-quantity-field"]');
      input.value = 0;
      changeInputHandler(input);
      el.parentNode.removeChild(el);
    });
  });
};

const cartInit = () => {
  window.lazyUpdate();
  window.initClearBasketItem();
  window.initImportFileHandler();
  window.initBasketGetOffer();
  window.initShareBasket();
  initQuantityInputs();
  initDeleteButtons();
  initQuantityBlock();
  window.basketCouponsInit();
  window.spollerUpd();
  window.getBasketItems();
  window.initDropMenuButtons();
  window.popupsInit();
  window.pointsIinputsInit();
};
window.cartInit = cartInit;

const refreshBasketItems = async () => {
  const formData = new FormData();
  formData.append('basketAction', 'refreshAjax');
  await updateBasketElements(formData);
};

document.addEventListener('DOMContentLoaded', () => {
  if (window?.location?.pathname === '/personal/cart/') {
    cartInit();
  }
  let basketItems = storageGet('basketItems');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      const newBasketItems = storageGet('basketItems');

      if (basketItems && newBasketItems) {
        const basketItemsKeys = Object.keys(basketItems);
        const newBasketItemsKeys = Object.keys(newBasketItems);

        if (basketItemsKeys.length !== newBasketItemsKeys.length) {
          refreshBasketItems();
          basketItems = newBasketItems;
        }
      }
    }
  });
});
